//      
import {connect} from "react-redux";
                                                  
import {getInitialProducts} from "../actions/products";
import App from "../components/App";
                                    
import {withTranslation} from "react-i18next";

function mapStateToProps(state                  ) {
	return {
		isIdle: state.content.isIdle,
		theme: state.config.intent,
		disclaimer: state.content.disclaimer,
		manufacturerTitle: state.config.manufacturerTitle,
	};
}

function mapDispatchToProps(dispatch          ) {
	return {
		getProducts: () => dispatch(getInitialProducts())
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
